import React from 'react';
import RandomString from 'randomstring';

import DialogAddFeedback from './Feedbacks/DialogAddFeedback';
import CreatePanelFeedbacksTable from './Feedbacks/TableFeedbacks';

class CreatePanelFeedbacks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogIsOpen: false,
            feedback: { type: null, question: null, leftLegend: null, rightLegend: null }
        };
    }

    handleOpenDialog = () => this.setState({ dialogIsOpen: true });
    handleCloseDialog = () => this.setState({ dialogIsOpen: false });

    handleChangeInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const { feedback } = this.state;

        this.setState({ feedback: { ...feedback, [name]: value } });
    }
    handleAddFeedback = () => {
        let { feedback } = this.state;
        const { feedbacks, onChangeFeedbacks } = this.props;

        feedback.id = RandomString.generate(16);
        feedbacks.push(feedback);
        onChangeFeedbacks(feedbacks);
        this.setState({ feedback: { type: null, question: null, leftLegend: null, rightLegend: null } });
        this.handleCloseDialog();
    }
    handleDeleteFeedback = (id) => {
        let { feedbacks, onChangeFeedbacks } = this.props;

        // Delete the element that has the given id using Array.filter
        feedbacks = feedbacks.filter((f) => f.id !== id);
        onChangeFeedbacks(feedbacks);
    }

    render() {
        const { feedbacks, instances } = this.props;
        const { feedback, dialogIsOpen } = this.state;

        return (
            <div>
                <DialogAddFeedback
                    feedback={feedback}
                    dialogIsOpen={dialogIsOpen}
                    onCloseDialog={this.handleCloseDialog}
                    onChangeInput={this.handleChangeInput}
                    onAddFeedback={this.handleAddFeedback} />
                <CreatePanelFeedbacksTable
                    hasBeenPlayed={this.props.hasBeenPlayed}
                    instances={instances}
                    feedbacks={feedbacks}
                    onDeleteFeedback={this.handleDeleteFeedback}
                    onOpenDialog={this.handleOpenDialog} />
            </div>
        );
    }
}

export default CreatePanelFeedbacks;